import { getDefaultClient } from '../../factory';
// @endpoint POST /entity/:app_id/:entity_id/query-keeper
// @controller UserAction.EntityPutQueryKeeper
export async function putEntityQueryKeeper(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-keeper`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/data-query
// @controller UserAction.EntityQuery
export async function queryEntity(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/data-query`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-filter
// @controller UserAction.EntityQueryFilter
export async function filterEntityQuery(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-filter`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/selection-query/:action
// @controller UserAction.EntityQuerySelection
export async function queryEntitySelection(appId, entityId, action, data) {
    // 调试日志，便于排查 selection-query/archive 不可用问题
    // console.debug('[queryEntitySelection] appId, entityId, action, data', appId, entityId, action, data)
    return getDefaultClient().post(`/entity/${appId}/${entityId}/selection-query/${action}`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/resolve-workflow
// @controller UserAction.EntityResolveWorkflow
export async function resolveEntityWorkflow(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/resolve-workflow`, data);
}
// @endpoint GET /entity/:app_id/:entity_id/row/:row_id
// @controller UserAction.EntityRow
export async function getEntityRow(appId, entityId, rowId, params) {
    return getDefaultClient().get(`/entity/${appId}/${entityId}/row/${rowId}`, params);
}
// @endpoint POST /entity/:app_id/:entity_id/delete-item
// @controller UserAction.EntityRowDelete
export async function deleteEntityRow(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/delete-item`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/restore-item
// @controller UserAction.EntityRowRestore
export async function restoreEntityRow(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/restore-item`, data);
}
// @endpoint PUT /entity/:app_id/:entity_id/row/:row_id
// @controller UserAction.EntityUpdate
export async function updateEntityRow(appId, entityId, rowId, data) {
    return getDefaultClient().put(`/entity/${appId}/${entityId}/row/${rowId}`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/validate-uniq
// @controller UserAction.EntityValidateUniq
export async function validateEntityUniq(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/validate-uniq`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/insert
// @controller UserAction.Insert
export async function insertEntity(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/insert`, data);
}
// Legacy compatibility alias for postFormData
export const postFormData = insertEntity;
// @endpoint POST /entity/:app_id/:entity_id/prepare
// @controller UserAction.InsertPrepare
export async function prepareEntityInsert(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/prepare`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-approve-users
// @controller UserAction.EntityWorkflowApproveUsers
export async function queryEntityWorkflowApproveUsers(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-approve-users`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-workflow-nodes
// @controller UserAction.EntityWorkflowNodes
export async function queryEntityWorkflowNodes(appId, entityId) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-workflow-nodes`);
}
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/get-subitems
// @controller UserAction.GetSubformItems
export async function getEntitySubformItems(appId, entityId, rowId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/get-subitems`, data);
}
